
import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"


// /////////////////////////////////////////////
// Variables
// /////////////////////////////////////////////

/*const userDefaults = {
    uid         : 0,          // From Auth
    displayName : "John Doe", // From Auth
    about       : "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
    photoURL    : require("@/assets/images/portrait/small/avatar-s-11.jpg"), // From Auth
    status      : "online",
    userRole    : "admin"
}*/

const userDefaults = {
    fullname: '',
    username: '',
    img: require("@/assets/images/portrait/small/default-avatar.png")
}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
    //AppActiveUser           : userDefaults,
    ActiveUser              : userDefaults,
    bodyOverlay             : false,
    isVerticalNavMenuActive : true,
    mainLayoutType          : themeConfig.mainLayoutType || "vertical",
    navbarSearchAndPinList  : navbarSearchAndPinList,
    reduceButton            : themeConfig.sidebarCollapsed,
    verticalNavMenuWidth    : "default",
    verticalNavMenuItemsMin : false,
    scrollY                 : 0,
    starredPages            : navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
    theme                   : themeConfig.theme || "light",
    themePrimaryColor       : colors.primary,

    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null,
}

export default state
